/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_AllInputs */

const en_admin_posts_all = /** @type {(inputs: Admin_Posts_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Posts`)
};

const zh_admin_posts_all = /** @type {(inputs: Admin_Posts_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有文章`)
};

/**
* | output |
* | --- |
* | "All Posts" |
*
* @param {Admin_Posts_AllInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_posts_all = /** @type {((inputs?: Admin_Posts_AllInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_AllInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_posts_all(inputs)
	return zh_admin_posts_all(inputs)
});
export { admin_posts_all as "admin.posts.all" }